import { motion } from "framer-motion";
import { Reveal } from "@/components/site/Reveal";
import { bookOnVrbo } from "@/lib/booking";
import { MapPin, Clock } from "lucide-react";

const points = [
  "Sleeps a whole team — 18 guests across 6 bedrooms",
  "Only ~15 minutes from the fields",
  "Come back to the lake, the pool and the hot tub between games",
  "One house beats a block of team hotel rooms",
];

export function RockerB() {
  return (
    <section id="baseball" className="relative bg-secondary/40 py-24 md:py-40 overflow-hidden">
      <span
        aria-hidden
        className="pointer-events-none absolute -bottom-10 left-4 md:left-12 font-display text-[9rem] md:text-[16rem] leading-none text-accent/10 select-none"
      >
        03
      </span>

      <div className="max-w-7xl mx-auto px-6 md:px-12 grid lg:grid-cols-12 gap-12 lg:gap-16 items-center relative">
        <div className="lg:col-span-5 order-2 lg:order-1">
          <div className="relative overflow-hidden rounded-[13rem_13rem_1.25rem_1.25rem] aspect-[3/4] shadow-2xl">
            <motion.img
              src="/property/baseball.jpg"
              alt="Youth baseball tournament game near Rocker B Ranch in Graford, Texas"
              initial={{ scale: 1.15 }}
              whileInView={{ scale: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 1.2, ease: [0.22, 1, 0.36, 1] }}
              className="absolute inset-0 h-full w-full object-cover grayscale-[0.15] saturate-[0.8]"
            />
            <div className="absolute inset-0 bg-primary/25 mix-blend-multiply" />
          </div>
        </div>

        <div className="lg:col-span-6 lg:col-start-7 order-1 lg:order-2">
          <Reveal>
            <p className="inline-flex items-center gap-2 text-xs sm:text-sm uppercase tracking-[0.22em] text-accent font-medium mb-6">
              <Clock className="h-4 w-4" strokeWidth={1.5} /> Chapter 03 — 15 Minutes to Rocker B Ranch
            </p>
          </Reveal>
          <Reveal delay={0.05}>
            <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl leading-[1.05] tracking-tight text-foreground text-balance">
              Playing a tournament at <em className="italic font-light">Rocker B Ranch?</em>
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="mt-8 text-base lg:text-lg leading-relaxed font-light text-muted-foreground max-w-xl">
              Skip the crowded team hotels. PK Lake House sits just 15 minutes from Rocker B Ranch — the premier youth
              baseball tournament resort in Graford, Texas. Bring the whole team or several families, spread out across six
              bedrooms, and unwind lakeside between games.
            </p>
          </Reveal>
          <Reveal delay={0.15}>
            <ul className="mt-8 space-y-3">
              {points.map((p) => (
                <li key={p} className="flex items-start gap-3 text-foreground">
                  <MapPin className="mt-1 h-4 w-4 shrink-0 text-accent" strokeWidth={1.6} />
                  <span className="font-light">{p}</span>
                </li>
              ))}
            </ul>
          </Reveal>
          <Reveal delay={0.2}>
            <button
              onClick={() => bookOnVrbo("baseball")}
              data-testid="baseball-book-button"
              className="mt-10 group inline-flex items-center gap-2 rounded-full bg-primary px-8 py-4 text-sm font-medium tracking-wide text-primary-foreground transition-all duration-300 hover:gap-3.5 hover:bg-primary/90"
            >
              Check tournament dates on VRBO
              <span aria-hidden className="transition-transform group-hover:translate-x-0.5">&rarr;</span>
            </button>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
